import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./Auth";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const {currentUser} = useContext(AuthContext);

  var currentHref = window.location.href;
  var splitter = currentHref.split("?");
  var toRedirect = "/";
  if(splitter.length > 1){
    toRedirect = toRedirect + "?" + splitter[1];
  }
  
  return (
    <Route
      {...rest}
      render={routeProps =>
        !!currentUser ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/signup" + toRedirect} />
        )
      }
    />
  );
};


export default PrivateRoute